import { ActionCreator } from "redux";
import {
	ActionType,
	DraggingStartedAction,
	DraggingEndedAction,
	DrawerOpenedAction,
	DrawerClosedAction,
	DrawerToggledAction
} from "./type";

export const startDragging: ActionCreator<DraggingStartedAction> = () => ({
	type: ActionType.UIDraggingStarted
});

export const endDragging: ActionCreator<DraggingEndedAction> = () => ({
	type: ActionType.UIDraggingEnded
});

export const openDrawer: ActionCreator<DrawerOpenedAction> = () => ({
	type: ActionType.UIDrawerOpened
});

export const closeDrawer: ActionCreator<DrawerClosedAction> = () => ({
	type: ActionType.UIDrawerClosed
});

export const toggleDrawer: ActionCreator<DrawerToggledAction> = () => ({
	type: ActionType.UIDrawerToggled
});
